/* eslint-disable camelcase */
import CancelOrderBlock from 'libs/wordpress/content/cmsBlocks/CancelOrderBlock';
import MaxWidthWrapper from 'components/wrappers/MaxWidthWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import moduleMargins from 'config/theme/moduleMargins';
import { wysiwygProp } from 'utils/proptypes/modules/textProps';

const CancelOrderModule = ({ content }) => (
    <MaxWidthWrapper includeContentMargins as="section" my={moduleMargins.md}>
        <CancelOrderBlock content={content} />
    </MaxWidthWrapper>
);

CancelOrderModule.propTypes = {
    content: PropTypes.shape({
        paragraph: wysiwygProp,
    }).isRequired,
};

export default CancelOrderModule;
